import { render } from "./ComplianceMtd.vue?vue&type=template&id=31cabed2"
import script from "./ComplianceMtd.vue?vue&type=script&lang=js"
export * from "./ComplianceMtd.vue?vue&type=script&lang=js"

import "./ComplianceMtd.vue?vue&type=style&index=0&id=31cabed2&lang=css"

import exportComponent from "C:\\Users\\Miftah Faridl\\Documents\\KIM-APPS\\motul-power-web-report\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__